import React from 'react';

import {withRouter} from 'react-router';

import {DocumentTaskReportPage} from 'app/documents/components/DocumentTaskReportPage';
import {
  useProcessByHashid,
  useProcessVersionDetail,
  useProcessVersions,
} from 'app/process/api';

import {ProcessPageSidebar} from './ProcessPageSidebar';

import type {WithRouterProps} from 'react-router';

export const ProcessTaskReportPage = withRouter(
  (
    props: WithRouterProps<{
      hashid: string;
      reportid: string;
      versionid: null | string;
    }>
  ) => (
    <DocumentTaskReportPage
      contentType="proceduregroup"
      useData={useProcessByHashid}
      useDataVersion={useProcessVersionDetail}
      useDataVersions={useProcessVersions}
      SideBarComponent={ProcessPageSidebar}
      {...props}
    />
  )
);
